import * as React from 'react';
import { useRef } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Alert, Dialog, ListItemText, ListItemButton, List, Divider, AppBar, Toolbar, IconButton, Typography, Slide, ListItemIcon, Button, Box, Tooltip } from '@mui/material';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { getNotificationKey, resolveNotificationTarget } from '../../utils/notificationTargets';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export function NotificationItems({ items, onNavigate, onDiscard }) {
  const discardGuardsRef = useRef(new Set());

  const handleDiscard = async (event, item) => {
    event.stopPropagation();
    const key = getNotificationKey(item);
    if (!key || discardGuardsRef.current.has(key)) return;
    discardGuardsRef.current.add(key);
    try {
      await onDiscard(item);
    } finally {
      discardGuardsRef.current.delete(key);
    }
  };

  const handleNavigate = (event, item) => {
    event.stopPropagation();
    const target = resolveNotificationTarget(item);
    if (target) onNavigate(target.targetSection, target.createdId);
  };

  return items.map((item) => (
    <React.Fragment key={getNotificationKey(item) ?? item.id}>
      <ListItemButton sx={{ alignItems: 'flex-start', flexWrap: { xs: 'wrap', sm: 'nowrap' } }}>
        <ListItemIcon sx={{ color: '#f44336' }}>
          <ErrorOutlineOutlinedIcon fontSize="large" />
        </ListItemIcon>
        <ListItemText
          primary={`¡Mensualidad de ${item.cliente.nombre} ${item.cliente.apellidos} a punto de terminar!`}
          secondary={
            item.dias_restantes < 0
              ? `Información: ${item.cliente.nombre} ${item.cliente.apellidos}, ${item.cliente.tipo_documento}: ${item.cliente.documento}, Cel: ${item.cliente.celular}, ${item.historial.tipo_vehiculo} ${item.historial.marca} ${item.historial.modelo} ${item.historial.color} ${item.historial.placa}, lleva ya ${Math.abs(item.dias_restantes)} días atrasado`
              : `Información: ${item.cliente.nombre} ${item.cliente.apellidos}, ${item.cliente.tipo_documento}: ${item.cliente.documento}, Cel: ${item.cliente.celular}, ${item.historial.tipo_vehiculo} ${item.historial.marca} ${item.historial.modelo} ${item.historial.color} ${item.historial.placa}, faltan ${item.dias_restantes} días para vencer`
          }
          sx={{
            '& .MuiListItemText-primary': {
              fontWeight: 'bold',
              fontFamily: 'Bebas Neue, sans-serif',
            },
            '& .MuiListItemText-secondary': {
              fontWeight: 'bold',
              fontFamily: 'Bebas Neue, sans-serif',
            },
          }}
        />
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: 1,
          ml: { xs: 0, sm: 1 },
          width: { xs: '100%', sm: 'auto' },
        }}>
          <Button
            sx={{
              color: '#f44336',
              minHeight: 44,
              minWidth: 48,
              '&:focus-visible': { outline: '3px solid currentColor', outlineOffset: 2 },
            }}
            onClick={(event) => handleNavigate(event, item)}
            aria-label={`Ir a notificación ${item.id}`}
          >
            IR
          </Button>
          <Tooltip title="Descartar notificación">
            <IconButton
              onClick={(event) => handleDiscard(event, item)}
              aria-label={`Descartar notificación ${item.id}`}
              sx={{ minWidth: 44, minHeight: 44, '&:focus-visible': { outline: '3px solid currentColor' } }}
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </ListItemButton>
      <Divider />
    </React.Fragment>
  ));
}

function DialogMensualidadesAlert({ handleCloseDialogMensualidades, openDialongMensualidades, handleSeeNotification, notifications = [], onDiscardNotification, notificationError = '' }) {
  return (
    <React.Fragment>
      <Dialog
        fullScreen
        open={openDialongMensualidades}
        onClose={handleCloseDialogMensualidades}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleCloseDialogMensualidades}
              aria-label="Cerrar notificaciones"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1, fontWeight: 'bold' }} variant="h6" component="div">
              Mensualidades a Punto de Terminar
            </Typography>
          </Toolbar>
        </AppBar>

        {notificationError && <Alert severity="error" aria-live="polite">{notificationError}</Alert>}
        <List>
          <NotificationItems
            items={notifications}
            onNavigate={handleSeeNotification}
            onDiscard={onDiscardNotification}
          />
        </List>
      </Dialog>
    </React.Fragment>
  );
}

export default DialogMensualidadesAlert;
